import * as React from 'react';
import { FC } from 'react';
import money from 'app/helpers/money';
import useBalance from 'app/useBalance';

type BalanceProps = {
  currency: string;
  balance: string | number;
  bonus: string | number;
};

const Balance: FC<BalanceProps> = (props) => {
  const balanceMsg = useBalance(props);

  const bonus = +balanceMsg.bonus;

  const amount = +(+balanceMsg.balance + bonus).toFixed(2);

  const classes = [bonus > 0 ? 'bonus' : '', 'amount'].join(' ');

  return (
    <span data-testid="balance" className={classes}>
      {money(amount, props.currency.toLowerCase())}
    </span>
  );
};

export default Balance;
